const protocol = window.location.protocol;
const hostname = window.location.hostname;
const port = window.location.port === '8081' ? 8080 : window.location.port;

export const BASE_URL = `${protocol}//${hostname}:${port}`;
